import React, { forwardRef } from "react";
import { CloseIcon, IconButton, ListItem, MoveTriggerIcon } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { SuggestedItem } from "./SuggestedItem";
import { NEW, SUGGESTION } from "./suggestionUtils";

export const DraggableSuggestionItem = forwardRef(
  (
    {
      item,
      onRemove,
      id,
      isDragging,
      isPreview,
      dragHandleProps,
      projectId,
      invalid,
      inputName,
      onUpdate,
      disableRemove,
      selectionMode,
      shouldShowEstimate,
      allowAllUsers,
    },
    ref
  ) => {
    const handleRemove = () => {
      if (typeof onRemove === "function") onRemove(id);
    };

    return (
      <ListItem
        className={classNames(
          "tw-w-full tw-leading-[unset] tw-bg-page-paper-main tw-p-0",
          {
            "tw-bg-theme-200": isDragging,
          },
          {
            "tw-shadow": isPreview,
          }
        )}
        ref={ref}
      >
        <div
          className={classNames("tw-flex tw-items-center tw-w-full tw-h-8", {
            "tw-opacity-0": isDragging && !isPreview,
          })}
        >
          <div className="tw-flex tw-items-center tw-w-full tw-group">
            <div
              className={classNames("drag-handle tw-flex tw-items-center tw-justify-center tw-w-6 tw-h-6", {
                "tw-opacity-0": isDragging,
                "tw-opacity-0 group-hover:tw-opacity-100": !isDragging && !isPreview,
              })}
              {...dragHandleProps}
            >
              <MoveTriggerIcon />
            </div>
            <SuggestedItem
              id={item.id}
              projectId={projectId}
              name={item.name}
              type={isPreview ? SUGGESTION : item.variant}
              assigneeId={item.assignee_id ? item.assignee_id : 0}
              startOn={item.start_on}
              dueOn={item.due_on}
              onUpdate={onUpdate}
              autoFocus={item.variant === NEW && !isDragging}
              selectionMode={selectionMode}
              disabled={isDragging}
              isPreview={isPreview}
              shouldShowEstimate={shouldShowEstimate}
              allowAllUsers={allowAllUsers}
              estimate={item?.estimate}
              jobTypeId={item?.job_type_id}
              invalid={invalid}
              inputName={inputName}
              assigneeIds={item.assignee_ids}
            />
            <div
              className={classNames("tw-flex tw-items-center", {
                "tw-opacity-0": isDragging && !isPreview,
                "tw-opacity-0 group-hover:tw-opacity-100": !isDragging && !isPreview,
                "tw-invisible": disableRemove,
              })}
            >
              <IconButton
                type="button"
                variant="text gray"
                size="small"
                onClick={handleRemove}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </div>
      </ListItem>
    );
  }
);

DraggableSuggestionItem.displayName = "DraggableSuggestionItem";

DraggableSuggestionItem.propTypes = {
  children: PropTypes.node,
  onMove: PropTypes.func,
  onDrop: PropTypes.func,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  position: PropTypes.number,
  projectId: PropTypes.number,
  task: PropTypes.object,
  onRemove: PropTypes.func,
  dragHandleProps: PropTypes.any,
  isDragging: PropTypes.bool,
  invalid: PropTypes.bool,
  inputName: PropTypes.string,
  isOver: PropTypes.bool,
  disableRemove: PropTypes.bool,
  isPreview: PropTypes.bool,
  item: PropTypes.any,
  onUpdate: PropTypes.func,
  selectionMode: PropTypes.string,
  shouldShowEstimate: PropTypes.bool,
  allowAllUsers: PropTypes.bool,
};

DraggableSuggestionItem.defaultProps = {
  shouldShowEstimate: false,
  invalid: false,
  allowAllUsers: false,
};
